import { useAuth } from "@hooks";
import { useStartCompanionChat } from "@hooks/use-start-companion-chat";
import { useEffect, useEffectEvent } from "react";
import { useSearchParams } from "react-router";

export function CompanionDeepLinkBridge() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { isUserAuthenticated } = useAuth();
  const { startChat } = useStartCompanionChat();

  const startSession = useEffectEvent(() => {
    startChat();
  });

  useEffect(() => {
    if (!searchParams.has("companion") || !isUserAuthenticated) {
      return;
    }

    const newParams = new URLSearchParams(searchParams);
    newParams.delete("companion");
    setSearchParams(newParams, { replace: true });
    startSession();
  }, [searchParams, setSearchParams, isUserAuthenticated]);

  return null;
}
